import React from 'react';
import { BarChart, LabelList, XAxis, Bar, YAxis, Cell, ResponsiveContainer } from 'recharts';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const AdmissionStatus = ({ data }) => {
  const {
    EarlyActionCount,
    ResEarlyActionCount,
    EarlyDecisionCount,
    RegularDecisionCount,
    RollingAdmissionCount,
    OtherAdmissiontypeCount,
  } = data;
  var x = 1.5;

  const graphData = [
    {
      label: 'EARLY ACTION',
      x,
      value: EarlyActionCount.aggregate.count,
    },
    {
      label: 'RESTRICTIVE EARLY ACTION',
      x,
      value: ResEarlyActionCount.aggregate.count,
    },
    {
      label: 'EARLY DECISION',
      x,
      value: EarlyDecisionCount.aggregate.count,
    },
    { label: 'REGULAR DECISION', x, value: RegularDecisionCount.aggregate.count, },
    {
      label: 'ROLLING ADMISSION',
      x,
      value: RollingAdmissionCount.aggregate.count,

    },
    {
      label: 'OTHER',
      x,
      value: OtherAdmissiontypeCount.aggregate.count,
    }
  ];

  const valueAccessor = attribute => ({ payload }) => {
    return payload[attribute];
  };

  return (
    <Card>
      <CardHeader
        title="Count of schools based on admission type"
        titleTypographyProps={{ variant: 'h5' }}
      />
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={graphData}
            margin={{
              top: 100,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >

            <XAxis
              dy={5}
              interval={0}
              tickLine={false}
              axisLine={false}
              dataKey="label"
              tick={{ fontSize: 12, fontWeight: 700, letterSpacing: 2 }}
            />
            <YAxis hide='true' domain={[0, 100]} />
            <Bar
              dataKey="x"
              stackId="a"
            >

              {graphData.map((i, idx) => (
                <Cell key={idx} fill='#EB5E28' />
              ))}

            </Bar>
            <Bar
              dataKey="value"
              stackId="a"

            >
              <LabelList dy={-6} position='top'
                fontSize='48'
                fontWeight='700'
                fill='#171819' valueAccessor={valueAccessor("value")} />
              {graphData.map((i, idx) => (
                <Cell key={idx} fill="#FFECE4" />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default AdmissionStatus;
